import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Page } from '@app/models/page';
import { PagesService } from '@app/services/pages.service';
import { UserService } from '@app/services/user.service';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NewsPageResolver implements Resolve<Page> {

  constructor(private service: PagesService, private userService: UserService, private router: Router) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Page> {
    const slugTitleWithId = route.paramMap.get('slugWithId');
    return this.service.getNewsPage(slugTitleWithId).pipe(
      map(data => {
        return new Page({ ...data, ModifiedByUserPhotoUrl$: this.userService.getUserPhotoByUpn(data.ModifiedByUserUpnId), OwnerUserPhotoUrl$: this.userService.getUserPhotoByUpn(data.OwnerUserUpnId) });
      }),
      catchError(() => {
        this.router.navigate(['']);
        return EMPTY;
      })
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ContentPageResolver implements Resolve<Page> {

  constructor(private service: PagesService, private userService: UserService, private router: Router) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Page> {
    const slugTitleWithId = route.paramMap.get('slugWithId');
    return this.service.getContentPage(slugTitleWithId).pipe(
      map(data => {
        return new Page({ ...data, ModifiedByUserPhotoUrl$: this.userService.getUserPhotoByUpn(data.ModifiedByUserUpnId), OwnerUserPhotoUrl$: this.userService.getUserPhotoByUpn(data.OwnerUserUpnId) });
      }),
      catchError(() => {
        this.router.navigate(['']);
        return EMPTY;
      })
    );
  }
}
